import React from "react";
import Div from "@jumbo/shared/Div";
import {
  Typography,
  Box,
  Tab,
  Table,
  TableBody,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Grid,
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { format } from "date-fns";
import { MdClose } from "react-icons/md";
import { CellNoborder, TableRowNoborder } from "app/pages/TableStyled";
import { DateFormatter } from "app/shared/ReuseComponents/DateFormatter";
import HistoryOverview from "app/shared/ReuseComponents/HistoryOverview";
import WorkflowApproverStatus from "app/shared/ReuseComponents/WorkflowApproverStatus";

const ResignationDocumentApproval = ({
  openViewRequest,
  setOpenViewRequest,
  value,
  handleChange,
  requests,
  approvalStatus,
  updateHistory,
  dateFormat,
}) => {
  const token = localStorage.getItem("accesstoken");
  const header = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  let userDetails = JSON.parse(localStorage.getItem("UserDetails"));
  const headApproverName = localStorage.getItem("ReportHeadName");
  const partnerId = parseInt(localStorage.getItem("PartnerId"));
  const WorkflowName = "Resignation";

  return (
    <>
      <Dialog maxWidth="lg" fullWidth open={openViewRequest}>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", mb: -2 }}>
          <Div sx={{ fontSize: "18px" }}>Resignation Overview</Div>
          <IconButton onClick={() => setOpenViewRequest(false)}>
            <MdClose />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 0, borderColor: "divider" }}>
              <TabList onChange={handleChange} aria-label="tabs">
                <Tab label="Overview" value="1" sx={{ fontSize: "16px", color: "#000000" }} />
                <Tab label="History" value="2" sx={{ fontSize: "16px", color: "#000000" }} />
              </TabList>
            </Box>

            {/* ========== Overview Panel ========== */}
            <TabPanel value="1" sx={{ p: 1.5 }}>
              <Grid container spacing={2}>
                {/* ===== Left Column: Labels ===== */}
                <Grid item xs={12} sm={6} md={3}>
                  <Typography variant="h5">Created Date</Typography>
                  <Typography variant="h5">Resignation No</Typography>
                  <Typography variant="h5">Employee Name</Typography>
                  <Typography variant="h5">Department</Typography>
                  <Typography variant="h5">Cadre Level</Typography>
                  <Typography variant="h5">Date of Resignation</Typography>
                  <Typography variant="h5">Reason</Typography>
                  <Typography variant="h5">Notice Period (Days)</Typography>
                  <Typography variant="h5">Requested Relieve Date</Typography>
                  <Typography variant="h5">Relieving Date After Notice Period</Typography>
                </Grid>

                {/* ===== Middle Column: Values ===== */}
                <Grid item xs={12} sm={6} md={6}>
                  <Typography variant="h5">
                    : <DateFormatter date={requests?.Created_Date} />
                  </Typography>
                  <Typography variant="h5">: {requests?.EmployeeResignation_Id || "-"}</Typography>
                  <Typography variant="h5">: {requests?.Employee_Name || "-"}</Typography>
                  <Typography variant="h5">: {requests?.Department || "-"}</Typography>
                  <Typography variant="h5">: {requests?.Cadrelevel || "-"}</Typography>
                  <Typography variant="h5">
                    : <DateFormatter date={requests?.Date_Of_Resignation} />
                  </Typography>
                  <Typography variant="h5">: {requests?.Reason || "-"}</Typography>
                  <Typography variant="h5">: {requests?.Notice_Period || "0"}</Typography>
                  <Typography variant="h5">
                    : <DateFormatter date={requests?.Request_To_Releive_Date} />
                  </Typography>
                  <Typography variant="h5">
                    : <DateFormatter date={requests?.Releive_Date_After_Noticeperiod} />
                  </Typography>
                </Grid>

                {/* ===== Right Column: Status Image ===== */}
                <Grid item xs={12} sm={12} md={3}>
                  <Box>
                    {requests?.Approved_Flg === true && requests?.Status === true ? (
                      <img
                        src="./../../../../../images/StatusFlg/Approved.png"
                        width={150}
                        height={70}
                        alt="Approved"
                      />
                    ) : requests?.Approved_Flg === false && requests?.Status === true ? (
                      <img
                        src="./../../../../../images/StatusFlg/Rejected.png"
                        width={150}
                        height={70}
                        alt="Rejected"
                      />
                    ) : (
                      <img
                        src="./../../../../../images/StatusFlg/Pending.png"
                        width={150}
                        height={70}
                        alt="Pending"
                      />
                    )}
                  </Box>
                </Grid>
              </Grid>

              {/* ===== Mobile Responsive Table ===== */}
              <Div id="no-more-tables" sx={{ display: { xs: "block", md: "none" } }}>
                <Table className="table table-bordered" sx={{ width: "100% !important", mt: 0.5, border: "none !important" }}>
                  <TableBody>
                    <TableRowNoborder>
                      <CellNoborder data-title="Resignation No">{requests?.EmployeeResignation_Id}</CellNoborder>
                      <CellNoborder data-title="Employee Name">{requests?.Employee_Name}</CellNoborder>
                      <CellNoborder data-title="Department">{requests?.Department}</CellNoborder>
                      <CellNoborder data-title="Date of Resignation">
                        <DateFormatter date={requests?.Date_Of_Resignation} />
                      </CellNoborder>
                      <CellNoborder data-title="Notice Period">{requests?.Notice_Period}</CellNoborder>
                    </TableRowNoborder>
                  </TableBody>
                </Table>
              </Div>

              {/* ===== Workflow Approver Status ===== */}
              <Box mt={3}>
                <WorkflowApproverStatus
                  WorkflowName={WorkflowName}
                  partnerId={partnerId}
                  approvalStatus={approvalStatus?.Approve}
                  HeadApproverName={headApproverName}
                />
              </Box>
            </TabPanel>

            {/* ========== History Panel ========== */}
            <TabPanel value="2">
              <HistoryOverview updatedHistory={updateHistory} itemId="Resignation No" />
            </TabPanel>
          </TabContext>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ResignationDocumentApproval;
